<template>
  <div>
    <e-charts :options="options" theme='light' :autoresize="true" :key="key" style="height: 100%"/>
  </div>
</template>

<script lang="js">
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'

@Component({components: {ECharts}})
export default class PieChart extends Vue {
  @Prop()  data;
  @Prop()  legend;
  @Prop()  series;
  get options() {return {
    tooltip: {
      trigger: 'item',
      formatter: '{b}: <b>{c}</b> ({d}%)'
    },
    series: this.series || [
      {
        name: 'Chart',
        type: 'pie',
        radius: ['0%', '90%'],
        avoidLabelOverlap: false,
        label: {
          show: true,
          position: 'inner',
          formatter: function(item) {
            return item.percent.toFixed()+'%';
          },
        },
        data: this.data.filter(e=>e.value)
      }
    ],
    animationDuration: 1000
  }
  };
  key = 0;

  @Watch('data', { deep: true })
  onDataChanged() {
    this.key++
  }
}
</script>

<style>
.echarts {
  width: 100%;
  height: 400px;
}
</style>
